import React from 'react'
import MaleIcon from '../../../common/MaleIcon';
import FemaleIcon from '../../../common/FemaleIcon';
import ProAMIcon from '../../../common/ProAMIcon';
import PairIcon from '../../../common/PairIcon';
import "./index.less"

function BasedOnGender(props) {
    const { item, number, fontSize, iconWrapperStyle, nameStyle } = props;
    return (<React.Fragment>
        {(item?.genderID === 1 /* Мужчина */) && <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <MaleIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center", ...nameStyle }}>{item?.lastname + " " + item?.firstname}</div>
        </div>}
        {(item?.genderID === 2 /* Женщина */) && <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <FemaleIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center", ...nameStyle }}>{item?.lastname + " " + item?.firstname}</div>
        </div>}
    </React.Fragment>)
}
function ProAM(props) {
    const { item, number, fontSize, iconWrapperStyle, text } = props;
    return (<React.Fragment>
        <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <ProAMIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} 
                    color={(item?.user?.genderID === 1)?"blue":"red"}/>
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center" }}>
                <div>{item?.user?.lastname + " " + item?.user?.firstname}</div>
                {(item?.partner) && <div style={{ color: "rgba(0,0,0,.65)", fontSize: "12px", fontStyle: "italic" }}>{item?.partner?.lastname + " " + item?.partner?.firstname}</div>}
                {(!item?.partner) && <div style={{ color: "red" }}>{text}</div>}
            </div>
        </div>
    </React.Fragment>)
}
function Pair(props) {
    const { item, number, fontSize, iconWrapperStyle, text } = props;
    return (<React.Fragment>
        <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <PairIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center" }}>
                <div>{item?.user?.lastname + " " + item?.user?.firstname}</div>
                {(item?.partner) && <div>{item?.partner?.lastname + " " + item?.partner?.firstname}</div>}
                {(!item?.partner) && <div style={{ color: "red" }}>{text}</div>}
            </div>
        </div>
    </React.Fragment>)
}


function Dancer(props) {
    const { item, number, selected, style, className, onClick, fontSize, iconWrapperStyle } = props;

    // console.log(item);
    // item?.user.genderID    
    // item?.user.lastname                
    // item?.partner
    // item?.partnerID
    // item?.tipTD
    // item?.tipTDID
    
    return (
        <div onClick={onClick} className={`dancer ${(className) ? className : ""} ${(selected) ? "selected" : ""}`} style={style}>
            {(!item?.tipTDID) && <BasedOnGender item={item?.user} number={number} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} />}
            {(item?.tipTDID === 1 /* Pro-AM */) && <React.Fragment>
                <ProAM item={item} number={number} text={"Нет ассистента"} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} />
            </React.Fragment>}
            {(item?.tipTDID === 2 /* Пары */) && <React.Fragment>
                <Pair item={item} number={number} text={"Нет партнера"} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} />
            </React.Fragment>}
        </div>
    )
}

export default Dancer